// @flow

import React from 'react'
import { ownerEvalutionImage } from 'frontend_core/dist/helpers/image'
import styled, { keyframes } from 'styled-components'

import HelpTooltip from 'components/atoms/HelpTooltip'
import Colors from 'components/styles/colors'
import { mediaMax } from 'components/styles/_media'
import { zIndexes } from 'frontend_core/dist/styles/variables'

const Evaluate = styled.div`
  margin: 0 -24px;
  ${mediaMax.tablet`
    margin-left: -12px;
    margin-right: -12px;
    overflow: hidden;
  `};
`

const EvaluateInner = styled.div`
  padding: 0 24px;
  font-size: 11px;
`

const EvaluateItem = styled.div`
  text-align: center;
  padding: 16px 0;
`

const EvaluateTitle = styled.h4`
  color: #999;
  ${mediaMax.tablet`
    font-size: 11px;
    letter-spacing: -1px;
  `};
`

const EvalTooltipDown = keyframes`
  0% {
    top: 15px;
    opacity: 0;
  }

  100% {
    top: 25px;
    opacity: 1;
  }
`

const EvaluateHelpTooltip = styled.span`
  display: none;
  position: absolute;
  left: -62px;
  top: 25px;
  width: 250px;
  z-index: ${zIndexes.baloon};
`

const EvaluateHelp = styled.span`
  position: relative;
  cursor: help;

  &:hover {
    ${EvaluateHelpTooltip} {
      /* stylelint-disable-line */
      display: block;
      animation: ${EvalTooltipDown} 0.25s 1;
    }
  }
`

const EvaluateQuestion = styled.i`
  margin-left: 2px;
  color: ${Colors.black};
`

const EvaluateValue = styled.div`
  font-size: 12px;
`

const EvaluateValueImage = styled.img`
  width: 35px;
  height: 32px;
  margin: 14px 0;
`

const EvaluateValueText = styled.span`
  display: block;
`

export type PropTypes = {
  confirmRateEvaluation: string,
  confirmRateText: string,
  replyRateEvaluation: string,
  replyRateText: string,
  replyTimeAvgEvaluation: string,
  replyTimeAvgText: string,
}

export default (props: PropTypes) => (
  <Evaluate>
    <EvaluateInner className="row">
      <EvaluateItem className="col-xs-4">
        <EvaluateTitle>
          {i18n.t('page.room.evalute1')}
          <EvaluateHelp>
            <EvaluateQuestion className="fa fa-question-circle" />
            <EvaluateHelpTooltip>
              <HelpTooltip
                {...{
                  text: i18n.t('page.room.captionOwnerEvaluation'),
                  beakHorizontalPosition: '28%',
                }}
              />
            </EvaluateHelpTooltip>
          </EvaluateHelp>
        </EvaluateTitle>
        <EvaluateValue>
          <EvaluateValueImage
            src={ownerEvalutionImage(props.confirmRateEvaluation)}
            alt=""
          />
          <EvaluateValueText>{props.confirmRateText}</EvaluateValueText>
        </EvaluateValue>
      </EvaluateItem>
      <EvaluateItem className="col-xs-4">
        <EvaluateTitle>{i18n.t('page.room.evalute2')}</EvaluateTitle>
        <EvaluateValue>
          <EvaluateValueImage
            src={ownerEvalutionImage(props.replyRateEvaluation)}
            alt=""
          />
          <EvaluateValueText>{props.replyRateText}</EvaluateValueText>
        </EvaluateValue>
      </EvaluateItem>
      <EvaluateItem className="col-xs-4">
        <EvaluateTitle>{i18n.t('page.room.evalute3')}</EvaluateTitle>
        <EvaluateValue>
          <EvaluateValueImage
            src={ownerEvalutionImage(props.replyTimeAvgEvaluation)}
            alt=""
          />
          <EvaluateValueText>{props.replyTimeAvgText}</EvaluateValueText>
        </EvaluateValue>
      </EvaluateItem>
    </EvaluateInner>
  </Evaluate>
)



// WEBPACK FOOTER //
// ./src/components/molecules/OwnerEvaluate/index.jsx